import { useEffect, useState } from "react";
import Slider from "react-slick";
import { getInlineLoader } from "../Helpers";

export default function HorizontalImageStrip({ images }) {
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    if (!images || images.length === 0) {
      return;
    }
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [images]);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2600,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="MainBodySection pt-0">
      <div className="container">
        <div className="tff-gallery-strip-heading">
          <div className="tff-section-kicker">Travel Inspirations</div>
          <h2 className="tff-section-title">
            Moments that capture the feel of Zanzibar.
            <span className="tff-section-underline"></span>
          </h2>
          <p className="font-light tff-section-lead">
            A glimpse of the island experiences we shape for guests who want beauty, comfort, and memorable journeys.
          </p>
        </div>

        <div className="tff-gallery-strip">
          <Slider {...settings}>
            {images.map((item, i) => {
              const imageSrc = typeof item === "string" ? item : item.image;
              const title = typeof item === "string" ? "" : item.title;
              const kicker = typeof item === "string" ? "" : item.kicker;
              const description = typeof item === "string" ? "" : item.description;
              const alt = typeof item === "string" ? "Zanzibar travel gallery" : item.alt || item.title;

              return (
                <div key={i} className="px-2">
                  <div className="tff-gallery-frame">
                    <img src={imageSrc} alt={alt} className="tff-gallery-image" />
                    {(kicker || title || description) && (
                      <div className="tff-gallery-overlay">
                        {kicker && <span className="tff-gallery-kicker">{kicker}</span>}
                        {title && <h3 className="tff-gallery-title">{title}</h3>}
                        {description && <p className="tff-gallery-description">{description}</p>}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </div>
  );
}
